import { render, staticRenderFns } from "./Noticle.vue?vue&type=template&id=604ad58d&scoped=true&"
import script from "./Noticle.vue?vue&type=script&lang=js&"
export * from "./Noticle.vue?vue&type=script&lang=js&"
import style0 from "./Noticle.vue?vue&type=style&index=0&id=604ad58d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604ad58d",
  null
  
)

export default component.exports